document.addEventListener("DOMContentLoaded", () => {
  // ---------- Config ----------
  const COLLECTION_HANDLE = "oddballs-x-joe";
  const GIFT_VARIANT_ID   = 40610504376381;
  const GIFT_PROPERTY     = "_joesGift";
  const MAX_PAGES         = 20;
  const SESSION_VARIABLE = "joe"
  const IDS_CACHE_KEY    = "joeCollectionIds";

  const params = new URLSearchParams(window.location.search);
  if (params.get("joeballs")) sessionStorage.setItem(SESSION_VARIABLE, "true");

  let collectionIds = null; // cached for the session
  let inFlight = false;
  let queued   = false;

  function readCachedIds() {
    try {
      const raw = sessionStorage.getItem(IDS_CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length ? new Set(parsed) : null;
    } catch (err) {
      return null;
    }
  }

  async function getCollectionProductIds() {
    if (collectionIds) return collectionIds;

    // products.json for this collection is ~437KB and was refetched on every
    // navigation. One crawl per session, parked in sessionStorage.
    const cached = readCachedIds();
    if (cached) {
      collectionIds = cached;
      return collectionIds;
    }

    const ids = new Set();
    for (let page = 1; page <= MAX_PAGES; page++) {
      const res = await fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const { products = [] } = await res.json();
      if (products.length === 0) break;
      products.forEach(p => ids.add(p.id));
    }
    collectionIds = ids;

    try {
      sessionStorage.setItem(IDS_CACHE_KEY, JSON.stringify([...ids]));
    } catch (err) {
      /* storage full or blocked — the in-memory cache still covers this page */
    }

    return ids;
  }

  // Only lines we added carry the property, so we never touch a gift
  // variant the customer put in the cart themselves.
  const isGiftLine = item => Boolean(item.properties && item.properties[GIFT_PROPERTY]);

  // One /cart.js for the whole page — see assets/ob-cart-state.js.
  const getCart = () =>
    window.OB && window.OB.getCart
      ? window.OB.getCart()
      : fetch("/cart.js").then(r => r.json());

  const addGift = () =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROPERTY]: "true" }
        }]
      })
    });

  // update.js takes line item keys, so multiple lines go in one request
  const applyUpdates = updates =>
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });

  async function syncGift() {
    if (inFlight) { queued = true; return; }
    inFlight = true;

    let changed = false;

    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(isGiftLine);

      // Nothing in the cart at all — nothing to do, and no need to crawl the collection.
      if (cart.items.length === 0) return;

      const hasRemoved = sessionStorage.getItem("removedJoe")
      const sessionQualifies = sessionStorage.getItem(SESSION_VARIABLE)

      // The session flags are free to read and gate the whole add path, so they
      // are checked before the collection crawl rather than after it. Only the
      // removal branch below runs for everyone else, and that needs the cart
      // alone — no products.json.
      const eligible = Boolean(sessionQualifies) && !hasRemoved;
      const ids = eligible ? await getCollectionProductIds() : null;
      const qualifies = eligible && cart.items.some(i => !isGiftLine(i) && ids.has(i.product_id));

      if (qualifies) {
        if (giftLines.length === 0) {
          await addGift();
          changed = true;
        } else {
          // Keep the first gift line at qty 1, zero out any duplicates.
          const updates = {};
          giftLines.forEach((line, i) => {
            const target = i === 0 ? 1 : 0;
            if (line.quantity !== target) updates[line.key] = target;
          });
          if (Object.keys(updates).length) {
            await applyUpdates(updates);
            changed = true;
          }
        }
      } else if (giftLines.length) {
        const updates = {};
        giftLines.forEach(line => { updates[line.key] = 0; });
        await applyUpdates(updates);
        changed = true;
      }
    } catch (err) {
      console.error("gift sync failed:", err);
    } finally {
      inFlight = false;
      if (changed) document.dispatchEvent(new CustomEvent("refreshDrawer"));
      if (queued) { queued = false; syncGift(); }
    }
  }

  document.addEventListener("checkJoe", syncGift);
  document.addEventListener("cart:updated", syncGift); // wire to whatever your theme fires

  syncGift();
});